import constants from './constants';
import helper from './helper';

const initialState = {
  application: null,
  currentApplicant: null,
  error: '',
  isTriangle: false,
  loading: false,
  ready: false,
  showApartment2: false,
  showDetails2: false,
  showMember2: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case constants.FETCHING_APPLICATION:
      return { ...state, loading: true, case: null };
    case constants.RECEIVED_APPLICATION:
      return {
        ...state,
        ready: true,
        loading: false,
        application: action.application,
        currentApplicant: addMoveTo(
          action.application,
          action.currentApplicant
        ),
      };
    case constants.FETCH_APPLICATION_ERROR:
      return { ...state, error: action.error, loading: false };
    case constants.CLEAR_ERROR_MESSAGE:
      return { ...state, error: '' };
    case constants.SHOW_MEMBER2:
      return { ...state, showMember2: true };
    case constants.HIDE_MEMBER_2:
      return { ...state, showMember2: false };
    case constants.SHOW_APARTMENT2:
      return { ...state, showApartment2: true };
    case constants.SHOW_DETAILS2:
      return { ...state, showDetails2: true };
    case constants.SET_TRIANGLE_SWAP:
      return { ...state, isTriangle: true };

    case constants.UPDATE_APPLICATION: {
      const index = `${action.fieldType.slice(0, -1)}${action.index}`;
      return {
        ...state,
        currentApplicant: {
          ...state.currentApplicant,
          [action.fieldType]: setUpdatedField(action, state, index),
        },
      };
    }

    default:
      return state;
  }
}

function setUpdatedField(action, state, index) {
  const isDetails = action.fieldType === 'details';
  const isSwapReason = action.fieldType === 'swapReason';
  if (isDetails || isSwapReason) return action.data;
  return {
    ...state.currentApplicant[action.fieldType],
    [index]: action.data,
  };
}

function addMoveTo(application, currentApplicant) {
  const { details } = currentApplicant;
  const swapAddress = helper.getSwapAddress(application, currentApplicant);
  const hasOneSwapaddress = swapAddress.length === 1;
  const moveToOne = helper.getMoveTo(details, hasOneSwapaddress, 1);
  const newCurrentApplicant = { ...currentApplicant };
  newCurrentApplicant.details.details1.moveToApartment = moveToOne;
  if (newCurrentApplicant.details.details2) {
    const moveToTwo = helper.getMoveTo(details, hasOneSwapaddress, 2);
    newCurrentApplicant.details.details2.moveToApartment = moveToTwo;
  }
  return newCurrentApplicant;
}



// WEBPACK FOOTER //
// ./src/features/Application/reducer.js